<template>
  <div>
    <div class="">
      <div class="field is-marginless">
        <div class="control has-icons-right quickview-search">
          <input
            ref="input"
            type="text"
            class="input is-large"
            v-model="search"
            placeholder="Rechercher dans la liste"
            :class="{'is-degrad-info has-text-white':search && search.length}">
          <span
            class="icon is-right is-size-3"
            :class="{'has-text-white':search && search.length}">
            <i class="fal fa-search"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="vadListeSelection">
      <ul>
        <template v-for="(g, key, i) in groupedLots">
          <li
            class="vadListeSelection-groupHeader"
            :key="`type-${key}-${i}`">
            <b class="has-text-grey is-size-6">
              <span v-if="key !== 'null'">{{ key | lotTypeLabel }}</span>
              <span v-else>Parking(s)</span>
              ({{ groupedLots[key].length }})
            </b>
          </li>
          <li
            v-for="l in groupedLots[key]"
            :key="`lot-${l.pk}-${i}`"
            class="columns is-gapless is-marginless is-border-bottom is-padding-left is-padding-right vadListeSelection-item"
            :class="{'is-disabled': (l.status === 'draft' || l.status === 'private')}"
            @click="select(l)">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
              <span
                class="dot is-small"
                :class="statusColors(l.status)"></span>
            </div>
            <div
              class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-left is-paddingless-right is-size-55 is-overflow-hidden is-nowrap hover-degrad">
              <div><b>{{ l.ref }}</b></div>
              <div class="columns is-multiline is-size-7 is-gapless">
                <div class="column is-12 is-gapless columns is-paddingless is-margin-bottom-xxsmall is-margin-top-xxsmall">
                  <div
                    v-if="l.sale_price_ttc"
                    class="column is-4 is-margin-right-xsmall">
                    <span class="has-text-grey">Prix : </span><span>{{ l.sale_price_ttc }} €</span>
                  </div>
                  <div
                    v-if="l.surface"
                    class="column is-4 is-margin-right-xsmall">
                    <span class="has-text-grey">Surface : </span><span>{{ l.surface }} m2</span>
                  </div>
                  <div
                    v-if="l.floor"
                    class="column is-3 is-margin-right-xsmall">
                    <span class="has-text-grey">Étage : </span><span>{{ l.floor | floorLabel }}</span>
                  </div>
                </div>
                <div
                  v-if="l.building"
                  class="column is-12 is-gapless is-paddingless">
                  <span class="has-text-grey">Bâtiment : </span><span>{{ l.building.name }}</span>
                </div>
              </div>
            </div>
            <div
              class="column is-self-vcentered is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall w80p">
              <a
                v-if="entitiesPk.includes(l.pk)"
                class="button is-xsmall is-circle is-action is-success">
                <span class="icon is-small"><i class="fas fa-check"></i></span>
              </a>
              <a
                v-else
                class="button is-xsmall is-circle is-action is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { groupBy } from 'lodash'
import { DefaultValues, Quickview } from '@/mixins'

export default {
  name: 'LotSelection',
  mixins: [DefaultValues, Quickview],
  props: {
    paramsQuickview: {
      type: Object
    }
  },
  data () {
    return {
      quickViewMode: this.paramsQuickview.mode,
      lots: [],
      search: ''
    }
  },
  computed: {
    filteredLots () {
      if (this.search && this.search.length) {
        const search = new RegExp(`(${this.search})`, 'igm')
        return this.lots.filter(x => x.ref.match(search))
      } else return this.paramsQuickview.sourceLots
    },
    groupedLots () {
      let order = groupBy([...this.filteredLots].sort((a, b) => {
        return b.lot_type - a.lot_type
      }), 'lot_type')
      let ordered = {}
      Object.keys(order).sort().forEach(function (key) {
        ordered[key] = order[key]
      })
      return ordered
    }
  },
  created () {
    this.lots = this.paramsQuickview.sourceLots
    if (this.paramsQuickview.lots && this.paramsQuickview.lots.length) {
      this.entities = this.lots.filter(x => this.paramsQuickview.lots.map(x => (x.lot && x.lot.pk) || x.pk).includes(x.pk))
    }
  },
  methods: {
    select (r) {
      if (this.entitiesPk.includes(r.pk)) {
        this.unselectEntity(r)
      } else {
        this.selectEntity(r)
      }
    },
    statusColors (val) {
      const COLORS = {
        available: 'has-background-available',
        optioned: 'has-background-optioned',
        sold: 'has-background-sold',
        draft: 'has-background-draft',
        archived: 'has-background-draft',
        reserved: 'has-background-reserved',
        pre_reserved: 'has-background-info'
      }
      return COLORS[val]
    }
  }
}
</script>
